import React from 'react'
import PropTypes from 'prop-types'

import MainFirst from './../block/MainFirst'
import ShortInfo from './../block/ShortInfo'
import Cards1 from './../block/Cards1'

import Raschet from './../block/Raschet'
import Kontakti from './../block/Kontakti'


class Obsada extends React.Component {

  render() {

    const { data, protocol, assets_path } = this.props

    return (
      <>
        <MainFirst
          data={data?.main_first || {}}
          protocol={protocol}
          assets_path={assets_path}
        />
        <ShortInfo
          data={data?.short_info || {}}
          assets_path={assets_path}
        />
        <Cards1
          list={data?.cards1?.list || []}
          cols={2}
          margin={`top-10-botom-50`}
          layout={4}
        />
        <Cards1
          title={`Услуги <span>компании Goodwin</span>`}
          rtext={`[Выполняем полный комплекс работ]`}
          text={`Компания гудвин специализируется на установке окон в деревянных домах, а также выполняет полный комплекс работ по выпиливанию проема, обустройству обсады, монтаже окон, внутренней и наружной отделки. Все работы выполняет одна команда, которая несет полную ответственность за свою работу. Это дает вам защиту от недоделок и "косяков", ведь когда работу выполняют разные подрядчики трудно найти того, кто будет отвечать за тот или иной брак.`}
          list={data?.cards2?.list || []}
          cols={4}
          margin={`bottom`}
          layout={5}
        />
        <Raschet
          data={data?.raschet || {}}
          assets_path={assets_path}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
        />
        <Kontakti
          data={data?.kontakti || {}}
          assets_path={assets_path}
          cardsOnly={true}
        />
      </>
    )
  }
}

Obsada.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

Obsada.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default Obsada